import { useMemo, useState } from 'react'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'
import {
  getAvailableTruckDays,
  getAvailableTruckDaysArg,
} from '../utils/bookableShipmentSavedSearch'

interface IUseTruckAvailabilityArgs {
  /**
   * Saved searches
   */
  savedSearches: BookableShipmentSavedSearch[]
  /**
   * The number of days to be returned in availableTruckDays
   */
  initialTotalBaseDays: number
}
/** Hook used to format truck availability from savedSearches */
export const useTruckAvailability = ({
  savedSearches = [],
  initialTotalBaseDays = 0,
}: IUseTruckAvailabilityArgs) => {
  const truckSavedSearches = useMemo(() => {
    return savedSearches.filter(s => s.sourceType === 'dispatcher_truck_availability')
  }, [savedSearches])
  // Number for determining how many days are to be added/subtracted to/from current date.
  const [addedDays, setAddedDays] = useState<number>(0)
  // Number for total amount of days returned in availableTruckDaysArg
  const [totalBaseDays, setTotalBaseDays] = useState<number>(initialTotalBaseDays)
  const availableTruckDaysArg = useMemo(() => getAvailableTruckDaysArg(totalBaseDays, addedDays), [
    addedDays,
    totalBaseDays,
  ])

  const availableTruckDays = useMemo(
    () => getAvailableTruckDays(availableTruckDaysArg, truckSavedSearches),
    [availableTruckDaysArg, truckSavedSearches]
  )
  const dayChangeHandler = (day: number) => setAddedDays(prev => prev + day)
  const addBaseDaysChangeHandler = (days: number) => setTotalBaseDays(prev => prev + days)
  return {
    availableTruckDays,
    dayChangeHandler,
    addBaseDaysChangeHandler,
  }
}

export default useTruckAvailability
